import { MaterialProductValueType, SiteMaterialDetail } from 'api';
import { MaterialComponentValueType } from 'features';

import { convertMaterialProductComponentAPIToMaterialComponentField } from '~/material-products/utils/convertMaterialProductComponentAPIToMaterialComponentField/convertMaterialProductComponentAPIToMaterialComponentField';

import { BaseSalesOrderFormValues } from '../../types';

const areBooleanFieldsEqual = (field1: boolean | undefined | null, field2: boolean | undefined | null) => {
  const isField1UndefinedOrNull = field1 === undefined || field1 === null;
  const isField2UndefinedOrNull = field2 === undefined || field2 === null;
  if (isField1UndefinedOrNull && isField2UndefinedOrNull) {
    return true;
  }
  return field1 === field2;
};

export const isMaterialProductSyncedWithMaterialProps = (
  values: BaseSalesOrderFormValues,
  siteMaterialDetail: SiteMaterialDetail | undefined
) => {
  if (!siteMaterialDetail) {
    return false;
  }
  let siteMaterialComponentValues: MaterialComponentValueType[] = [];
  if (siteMaterialDetail?.material_product?.material_component_values) {
    siteMaterialComponentValues = convertMaterialProductComponentAPIToMaterialComponentField(
      siteMaterialDetail.material_product?.material_component_values,
      MaterialProductValueType.SELLER
    );
  }
  const formSellerComponentValues = values.seller_material_component_values || [];

  siteMaterialComponentValues.sort((a, b) => a.supported_component_id - b.supported_component_id);
  formSellerComponentValues.sort((a, b) => a.supported_component_id - b.supported_component_id);

  for (let i = 0; i < siteMaterialComponentValues.length; i++) {
    if (formSellerComponentValues.length <= i) {
      return false;
    }
    if (
      siteMaterialComponentValues[i].min_value !== formSellerComponentValues[i].min_value ||
      siteMaterialComponentValues[i].max_value !== formSellerComponentValues[i].max_value ||
      !areBooleanFieldsEqual(siteMaterialComponentValues[i].boolean_value, formSellerComponentValues[i].boolean_value)
    ) {
      return false;
    }
  }

  if (
    !areBooleanFieldsEqual(values.is_food_grade, siteMaterialDetail?.material_product?.is_food_grade) ||
    !areBooleanFieldsEqual(values.has_caps_and_labels, siteMaterialDetail?.material_product?.has_caps_and_labels)
  ) {
    return false;
  }

  return (
    values.material_spec_id === siteMaterialDetail?.material_product?.material_spec.id &&
    values.grade_id === siteMaterialDetail?.material_product?.material_grade.id &&
    values.origin_id === siteMaterialDetail?.material_product?.material_origin?.id
  );
};
